import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { searchRouteViewpoint, updateRouteSearchMapCriteria } from "../../redux/actions/routeActions"
import { setupNavigation } from "../../redux/actions/navItemsActions"
import { Map, TileLayer, Marker, Polyline } from 'react-leaflet';
import SelectInput from "../common/formfields/SelectInput"
import L from 'leaflet';
import MarkerClusterGroup from 'leaflet.markercluster';
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import "./RouteSearch.css";
import Spinner from "../common/Spinner";
import * as apiConfig from "../../api/config";
import $ from 'jquery';
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/autocomplete.css';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/autocomplete'; 
import geocoder from 'google-geocoder'; 
import routeMapSearchStateReducer from "../../redux/reducers/routeMapSearchStateReducer";
import { Helmet } from 'react-helmet';

function ExplorePage({
    user,
    setupNavigation,
    searchRouteViewpoint,
    updateRouteSearchMapCriteria,
    routeMapSearchState,
    history
}) {

    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(true);
    const [searching, setSearching] = useState(0);
    const [userLocation, setUserLocation] = useState([0, 0])
    const [categoryFilter, setCategoryFilter] = useState(routeMapSearchState.categoryFilter ? routeMapSearchState.categoryFilter  : "All");
    const [clusterMarkers, setClusterMarkers] = useState([]);
    const [clusterGroup, setClusterGroup] = useState(L.markerClusterGroup());
    const [loadedRoutes, setLoadedRoutes] = useState([]);

    const mapRef = useRef(null);
    const locationRef = useRef(null);
    var mapSearch = 0



    const navigationItems =
    {
        sections: [{
            name: 'Search',
            items: [
                {
                    path: '/routes/explore',
                    text: 'Explore Map',
                    icon: 'fas fa-map-marked-alt'
                },
                {
                    path: '/routes/search',
                    text: 'Keyword Search',
                    icon: 'fas fa-search'
                }
            ]
        }]
    };

    useEffect(() => {
        document.title = "Explore | JustGoRide";

        if (!routeMapSearchState || !routeMapSearchState.centre) {
            if (navigator.geolocation) {
                setProcessing(true);
                const options = {
                    timeout: 5000
                };
                navigator.geolocation.getCurrentPosition(setBrowserLocation, setDefaultLocation, options);
            } else {
                setDefaultLocation();
            }
        } else {
            setProcessing(false);
        }
        setupNavigation(navigationItems);
    }, []);
    
    function setBrowserLocation(position) {
        if (routeMapSearchState && routeMapSearchState.centre) {
            setProcessing(false);
            return; 
        } 

        setUserLocation([position.coords.latitude, position.coords.longitude])
        setProcessing(false);
    }

    function setDefaultLocation() {
        setUserLocation([52.912454, -1.446462]);
        setProcessing(false);
    }

    function getCentre() {
        if (routeMapSearchState && routeMapSearchState.centre) {
            return routeMapSearchState.centre;
        }

        return userLocation;
    }

    function getZoom() {
        if (routeMapSearchState && routeMapSearchState.zoom) {
            return routeMapSearchState.zoom;
        }
        return 12; 
    }

    function onLayerLoading() {
        var map = mapRef.current.leafletElement;
        map._layersMaxZoom = 19;
        map._layersMinZoom = 7;
        map.addLayer(clusterGroup);

        var geo = geocoder({
            key: apiConfig.GOOGLE_API_KEY, 
            region: "uk"
        });

        var location = locationRef.current; 
        $(location).autocomplete({
            source: function (request, response) {
                geo.find(request.term, function (err, res) {
                    var results = new Array();
                    if (res[0]) {
                        geocoder.firstItem = res[0];
                        for (var i = 0; i < res.length; i++) {
                            res[i].label = res[i].formatted_address;
                            results.push(res[i]);
                        }
                        response(results);
                    }
                    else {
                        response();
                    }
                });

            },
            select: function (event, ui) {
                $(location).val(ui.item.formatted_address); 
                map.setView(L.latLng(ui.item.location.lat, ui.item.location.lng));
                map.setZoom(14);
            }
        });
    }

    function onSearch() {
        var geo = geocoder({
            key: apiConfig.GOOGLE_API_KEY, 
            region: "uk"
        });
        var map = mapRef.current.leafletElement;
        var location = locationRef.current; 
        geo.find($(location).val(), function (err, res) {
                var results = new Array();
                if (res[0]) {
                    geocoder.firstItem = res[0];
                    map.setView(L.latLng(res[0].location.lat, res[0].location.lng));
                    map.setZoom(14);
                }
                else {
                    alert('No Results Found!');
                }
            });
    }

    function onLayerLoad(e) {
        setSearching(++mapSearch) 
        var map = mapRef.current.leafletElement;
        var bounds = map.getBounds(); 
        var catFilter = categoryFilter; 
        if (routeMapSearchState && routeMapSearchState.categoryFilter) {
            setCategoryFilter(routeMapSearchState.categoryFilter);
            catFilter = routeMapSearchState.categoryFilter;
        }

        searchRouteViewpoint(bounds.getNorthEast(), bounds.getSouthWest(), loadedRoutes)
            .then((routes) => {
                routes.map((route) => {
                    if (!loadedRoutes.includes(route.routeId.toString())) {

                        var cat;
                        switch (route.category) {
                            case 'Road':
                                cat = 'road';
                                break;
                            case 'OffRoad':
                                cat = 'mtb';
                                break;
                            case 'Gravel':
                                cat = 'gravel'
                                break;
                        }

                        var pointIcon = L.icon({
                            iconUrl: `/resources/images/routes/${cat}point.png`,
                            iconSize: [12, 19],
                            iconAnchor: [6, 19]
                        })
                        var marker = L.marker(route.startPoint, { icon: pointIcon });
                        marker.category = cat; 

                        var popup = L.popup({ closeButton: true, offset: L.point(0, -15) })
                        var popupContent = `<a href="/Routes/${route.routeId}">
                                                <img class="route-badge" alt="${cat}" src="/resources/images/routes/${cat}badge.png"/>
                                                <div class="route-detail">
                                                    <div class="route-title">${route.name}</div>
                                                    <p>Distance: ${ user.preferredMeasurementUnits == 'Statute' ? `${Math.round((route.distanceKm * 0.621371192) * Math.pow(10, 2)) / Math.pow(10, 2)}mi` : `${Math.round(route.distanceKm * Math.pow(10, 2)) / Math.pow(10, 2)}km`}</p>
                                                </div>
                                            </a>
                                            <a href="/Routes/${route.routeId}">
                                                <div class="preview"><img src="${apiConfig.API_URL}routes/routepreview/${route.routeId}.png" /></div>
                                            </a>`

                        popup.setContent(popupContent);
                        marker.bindPopup(popup);

                        clusterMarkers.push(marker);
                        loadedRoutes.push(route.routeId.toString());

                    }
                });

                map.removeLayer(clusterGroup);
                clusterGroup.clearLayers();
                
                clusterGroup.addLayers(filterByCategory(clusterMarkers, catFilter));
                map.addLayer(clusterGroup)

                updateRouteSearchMapCriteria({ centre: map.getCenter(), zoom: map.getZoom(), categoryFilter: categoryFilter })

                setTimeout(() => { setSearching(--mapSearch); }, 1000);
            });
    }

    function onTileLoad(e) {
        /*
        console.log('tileLoad');
        var map = mapRef.current.leafletElement;
        map.maxZoom = 15; 

        var x = e.coords.x;
        var y = e.coords.y;
        var z = e.coords.z;
        var northEast = new L.LatLng(tile2lat(y, z), tile2long(x - (-1.0), z)); 
        var southWest = new L.LatLng(tile2lat(y - (-1.0), z), tile2long(x, z));
        var bounds = new L.LatLngBounds(southWest, northEast);


        L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
       */
    }

    function tile2long(x,z) {
        return (x/Math.pow(2,z)*360-180);
    }

     function tile2lat(y,z) {
        var n=Math.PI-2*Math.PI*y/Math.pow(2,z);
        return (180/Math.PI*Math.atan(0.5*(Math.exp(n)-Math.exp(-n))));
    }
       
    function onFilterCategory(e) {
        var map = mapRef.current.leafletElement;

        var option = e.target.value; 
        if (option === categoryFilter) {
            return; 
        }

        var selection = filterByCategory(clusterMarkers, option);

        map.removeLayer(clusterGroup);
        clusterGroup.clearLayers();
        map.addLayer(clusterGroup);
        clusterGroup.addLayers(selection)

        setCategoryFilter(option);  
        updateRouteSearchMapCriteria({ centre: map.getCenter(), zoom: map.getZoom(), categoryFilter: option })
    }

    function filterByCategory(markers, option) {
         var selection = [];
        clusterGroup.clearLayers();
        switch (option) {
            case "All":
                selection = markers; 
                break;
            case "Road":
                selection = markers.filter((m) => {
                    return m.category === "road";
                });
                break;
            case "Off Road":
                selection = markers.filter((m) => {
                    return m.category === "mtb";
                });
                break;
            case "Gravel":
                selection = markers.filter((m) => {
                    return m.category === "gravel";
                });
                break;
        }

        return selection; 
    }

    return (
        <React.Fragment>
            {
            processing ?
                <Spinner /> : (
                    <React.Fragment>
                        <Helmet>
                            <meta name="title" content="Search for a GPX Cycle Route | JustGoride " />
                            <meta name="description" content="Search for GPX cycle routes to go ride on your bike. This search will let you find cycle routes and bike trails that you can then download as a GPX Route file and upload to a GPS device such as Garmin or Satmap." />
                            <meta name="keywords" content="global gpx route sharing, download gpx route files, upload gpx route files, create gpx route files, search gpx route file catalog, bike rides and routes in gpx format" />
                        </Helmet>
                        <div className="explore-toolbar col-md-9 ml-sm-auto col-xl-10">
                            
                              <div className="row">
                                <div className="col-sm">
                                    <h3>Route Map</h3>
                                </div>
                                <div className="col-sm">
                                    <div className="input-group mb-0">
                                            <input ref={locationRef} type="text" className="form-control form-control-sm" placeholder="Map Center..." aria-label="Location Search" disabled={searching > 0} />
                                        <div className="input-group-append">
                                            <button type="submit" className="btn btn-secondary btn-sm" type="submit" disabled={searching > 0}><span className="fas fa-search" onClick={onSearch}></span></button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm">
                                    <div className="form-group row">
                                        <label htmlFor="categoryFilter" className="col-sm-2 col-form-label">Category</label>
                                            <div className="col-sm-10">
                                                <select className="form-control form-control-sm" id="categoryFilter" value={routeMapSearchState.categoryFilter} onChange={onFilterCategory} disabled={searching > 0} >
                                                <option>All</option>
                                                    <option>Road</option>
                                                    <option>Gravel</option>
                                                    <option>Off Road</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                              </div>
                        </div>

                        <div className="explore-map-container">
                                {searching > 0 &&
                                    <div className="loading-status">
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="sr-only"></span>
                                        </div>
                                        Searching Viewport...
                                    </div>
                                }
                                <Map ref={mapRef} center={getCentre()} zoom={getZoom()} onTileLoad={onTileLoad}>
                                <TileLayer
                                        attribution='&amp;copy <a href="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png">OpenStreetMap</a> contributors'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" onLoad={onLayerLoad} onTileLoad={onTileLoad} onLoading={onLayerLoading}
                                />
                            </Map>
                        </div>
                    </React.Fragment>
                )}
        </React.Fragment>
    );

}

ExplorePage.propTypes =
    {
        user: PropTypes.object.isRequired,
        errorMessage: PropTypes.string,
        setupNavigation: PropTypes.func.isRequired,
        searchRouteViewpoint: PropTypes.func.isRequired, 
        updateRouteSearchMapCriteria: PropTypes.func.isRequired
    }


function mapStateToProps(state) {
    return {
        user: state.user,
        routeMapSearchState: state.routeMapSearchState
    };
}

const mapDispatchToProps = {
    setupNavigation,
    searchRouteViewpoint,
    updateRouteSearchMapCriteria
}

export default connect(mapStateToProps, mapDispatchToProps)(ExplorePage); 


/*

<div className="col-6 float-left">

                                <h1 className="h2 mb-0">Explore</h1>
                                <span>this is the left of the top bar </span>

                            </div>

                            <div className="btn-toolbar mb-2 mb-md-0 col-6">
                                <form onSubmit={handleSearch}>
                                    <div className="input-group mb-0">

                                        <input type="text" className="form-control" placeholder="Search..." value={keywords} onChange={handleChange} aria-label="Keyword Search Term" />
                                        <div className="input-group-append">
                                            <button type="submit" className="btn btn-secondary" type="submit"><span className="fas fa-search"></span></button>
                                        </div>
                                        
                                    </div>
                                    <SelectInput
                                        name="category"
                                        label="Category"
                                        value={"All"}
                                        defaultOption="Select Category"
                                        options={[
                                            {
                                                value: "Road", 
                                                text: "Road"
                                            }, 
                                            {
                                                value: "OffRoad", 
                                                text: "Off Road"
                                            }
                                        ]}
                                        onChange={filterCategory}
                                        error={errors.category}
                                    />
                                </form>
                            </div>

    })

*/


// WEBPACK FOOTER //
// ./src/components/routes/ExplorePage.js